import type { FormError } from 'asap-team/asap-tools';

export const phoneError: FormError = {
  name: 'invalidPhone',
  text: 'Phone is invalid',
  rules: ['touched', 'dirty'],
};
